// Fetches Embed Url and Embed token for PowerBi
import handlePowerBiInsights from "./handlePowerBiInsights";
import handlePowerBiReport from "./handlePowerBiReport";
import CryptoJS from 'crypto-js'

export default async function handlePowerBiLogin(powerBiReportInfo, token) {
  // FETCH - EMBEDDED INFO
  if(powerBiReportInfo.hasOwnProperty('workspace_id') && powerBiReportInfo.workspace_id !== '')
    await handlePowerBiInsights(powerBiReportInfo.workspace_id, token)
  if(powerBiReportInfo.hasOwnProperty('report_id') && powerBiReportInfo.report_id !== '')
    await handlePowerBiReport(powerBiReportInfo, token)

  // Save PowerBI WorkspaceId
  localStorage.setItem(
    "powerBiWorkspaceId",
    CryptoJS.AES.encrypt(
      powerBiReportInfo.workspace_id,
      process.env.REACT_APP_PASS
    ).toString()
  );
}


// WEBPACK FOOTER //
// ./src/util/powerBi/handlePowerBiLogin.jsx